import axios from 'axios';
import ENV from '../../../../environment';
import {useQuery, useMutation} from '@tanstack/react-query';

const {SUPERSET_URL, SUPERSET_USERNAME, SUPERSET_PASSWORD} = ENV;
const supersetUrl: string = SUPERSET_URL || 'http://localhost:8088';
const supersetApiUrl: string = `${supersetUrl}/api/v1/security`;
interface LoginResponse {
  access_token: string;
}
interface GuestTokenResponse {
  token: string;
}
export const getAccessToken = async (): Promise<string> => {
  const loginBody = {
    password: SUPERSET_PASSWORD || 'admin',
    provider: 'db',
    refresh: true,
    username: SUPERSET_USERNAME || 'admin',
  };
  const loginHeaders = {
    'Content-Type': 'application/json',
  };
  try {
    const {data} = await axios.post<LoginResponse>(
      `${supersetApiUrl}/login`,
      loginBody,
      {headers: loginHeaders},
    );
    //console.log('Access Token', data.access_token);
    return data.access_token;
  } catch (error) {
    console.error('Error during login:', error);
    throw error;
  }
};
export const useAccessToken = () => {
  return useQuery<string, Error>(['accessToken'], getAccessToken);
};
export const getGuestToken = async (
  accessToken: string,
  dashboardId: string,
): Promise<string> => {
  const guestTokenBody = JSON.stringify({
    resources: [{type: 'dashboard', id: dashboardId}],
    rls: [],
    user: {
      username: 'report-viewer',
      first_name: 'report-viewer',
      last_name: 'report-viewer',
    },
  });
  const guestTokenHeaders = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${accessToken}`,
  };
  try {
    const {data} = await axios.post<GuestTokenResponse>(
      `${supersetApiUrl}/guest_token/`,
      guestTokenBody,
      {headers: guestTokenHeaders},
    );
    //console.log('Guest Token', data.token);
    return data.token;
  } catch (error) {
    console.error('Error during guest token retrieval:', error);
    throw error;
  }
};
export const useGuestToken = () => {
  return useMutation((params: {accessToken: string; dashboardId: string}) =>
    getGuestToken(params.accessToken, params.dashboardId),
  );
};
